import { ROUTES } from 'constants/routes'

const defaultNavigationConfig = ({ user = {} }) =>
  !user?.id
    ? []
    : [
        {
          path: ROUTES.SERVICES,
          key: 'services_list',
          label_key: 'navigation::nav_menu.advertisement_networks',
          icon: 'gramophone',
        },
        {
          path: ROUTES.FINANCE,
          key: 'finance',
          label_key: 'navigation::nav_menu.finance',
          icon: 'card',
          routes: [
            {
              path: ROUTES.FINANCE_WALLETS,
              key: 'finance/wallets',
              label_key: 'navigation::finance.navigation.wallets',
              icon: 'business-cards',
            },
            {
              exact: true,
              path: ROUTES.FINANCE_INVOICES,
              key: 'finance/invoices',
              label_key: 'navigation::finance.navigation.invoices',
              icon: 'document',
            },
            {
              exact: true,
              path: ROUTES.FINANCE_PAYMENT_PROFILES,
              key: 'finance/payment-profiles',
              label_key: 'navigation::finance.navigation.payment_profiles',
              icon: 'users',
            },
            {
              exact: false,
              key: 'finance/promised-payment',
              label_key: 'navigation::finance.navigation.promised_payment',
              path: ROUTES.FINANCE_PROMISED_PAYMENT,
              icon: 'time-clock',
            },
          ],
        },

        {
          path: ROUTES.STATISTICS,
          exact: true,
          label_key: 'navigation::statistics.navigation.main',
          key: 'statistics_main',
          icon: 'statistics',
        },
        {
          exact: true,
          path: ROUTES.ADVERTISERS,
          key: 'advertisers_list',
          label_key: 'navigation::user.navigation.advertisers',
          icon: 'clients',
        },
        {
          path: ROUTES.PULSE,
          exact: true,
          label_key: 'navigation::nav_menu.pulse',
          key: 'statistics_pulse',
          icon: 'pulse',
        },
        {
          key: 'recommendations',
          label_key: 'navigation::recommendations.navigation.main',
          icon: 'like',
          routes: [
            {
              path: ROUTES.RECOMMENDATIONS_AUDITS,
              exact: true,
              label_key: 'navigation::recommendations.navigation.audits',
              key: 'recommendations/audits',
              icon: 'document',
            },
            {
              path: ROUTES.RECOMMENDATIONS_BENCHMARKS,
              exact: true,
              label_key: 'navigation::recommendations.navigation.benchmarks',
              key: 'recommendations/benchmarks',
              icon: 'chart-search',
            },
            {
              path: ROUTES.RECOMMENDATIONS_CAMPAIGNS,
              //exact: true,
              label_key: 'navigation::recommendations.navigation.campaigns',
              key: 'recommendations/campaigns',
              icon: 'documents-settings',
            },
          ],
        },
        {
          path: ROUTES.AGENCY_CLIENTS,
          label_key: 'navigation::nav_menu.agency_dashboard',
          key: 'agency/my-agency',
          icon: 'profile',
        },
        ...(user?.is_referral_program_available
          ? [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'navigation::referral.navigation.affiliate_account',
                icon: 'profile-window',
                routes: [
                  {
                    path: ROUTES.REFERRAL_LINKS,
                    exact: true,
                    key: 'referral/links',
                    icon: 'copy-link',
                    label_key: 'navigation::referral.navigation.referral-links',
                  },
                  {
                    path: ROUTES.REFERRAL_CLIENTS,
                    exact: true,
                    key: 'referral/referral-clients',
                    icon: 'users',
                    label_key: 'navigation::referral.navigation.referral-clients',
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'navigation::referral.navigation.payout-profiles',
                    icon: 'card-arrow-up',
                  },
                ],
              },
            ]
          : [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'navigation::referral.navigation.referral_program',
                icon: 'two-users',
                routes: [
                  {
                    exact: true,
                    path: ROUTES.REFERRALS,
                    key: 'referrals/main',
                    label_key: 'navigation::referral.navigation.referrals',
                    icon: 'users',
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'navigation::referral.navigation.payout-profiles',
                    icon: 'card-arrow-up',
                  },
                ],
              },
            ]),
        {
          path: ROUTES.PARTNERS,
          label_key: 'navigation::nav_menu.partners',
          key: 'partners',
          icon: 'money',
        },
        /* {
          path: ROUTES.MARKETPLACE_TOOLS,
          key: 'marketplace-tools/list',
          label_key: 'navigation::nav_menu.marketplace_tools',
          icon: 'tools',
        }, */
        /* {
          path: ROUTES.BANK_CARDS,
          exact: true,
          key: 'virtual-cards',
          label_key: 'common::nav_menu.bank_cards',
          icon: 'card-cloud',
        }, */
      ]

export default defaultNavigationConfig
